import type { IPackageType } from '@telecom/shared/domain/permission/apis/package-api';

export const PackageInfoService = Symbol.for('PackageInfoService');

/**
 * 套餐信息服务
 * 负责获取和管理用户套餐信息
 */
export interface PackageInfoService {
    /**
     * 获取用户套餐信息
     * @returns 用户套餐类型列表
     */
    getPackageInfo(): Promise<IPackageType[]>;
}
